import { render, staticRenderFns } from "./BeginForm.vue?vue&type=template&id=b3eb305a&scoped=true&"
import script from "./BeginForm.vue?vue&type=script&lang=js&"
export * from "./BeginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eb305a",
  null
  
)

export default component.exports